// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range {
  margin: 0;
  width: 100%;
  -webkit-appearance: none;
  background-color: transparent;
}

.range:focus {
  outline: none;
}

.range::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: var(--ui-border-color-dark);
  border-radius: 0px;
  border: 0px solid var(--ui-border-color-dark);
}

.range::-moz-range-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: none;
  background-color: var(--ui-border-color-dark);
  border-radius: 0px;
  border: 0px solid var(--ui-border-color-dark);
}

.range::-webkit-slider-thumb {
  -webkit-box-shadow: none;
          box-shadow: none;
  border: 0px solid var(--active-color);
  -webkit-box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
  height: 21px;
  width: 11px;
  border-radius: 11px;
  background: var(--active-color);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -10px;
}

.range::-moz-range-thumb {
  box-shadow: none;
  border: 0px solid var(--active-color);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
  height: 21px;
  width: 11px;
  border-radius: 11px;
  background: var(--active-color);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -10px;
}

.range::-moz-focus-outer {
  border: 0;
}

.range-example {
  background: black;
  height: 2em;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/range/Range.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,wBAAwB;UAChB,gBAAgB;EACxB,6CAA6C;EAC7C,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,qCAAqC;EACrC,qDAAqD;UAC7C,6CAA6C;EACrD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".range {\n  margin: 0;\n  width: 100%;\n  -webkit-appearance: none;\n  background-color: transparent;\n}\n\n.range:focus {\n  outline: none;\n}\n\n.range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: var(--ui-border-color-dark);\n  border-radius: 0px;\n  border: 0px solid var(--ui-border-color-dark);\n}\n\n.range::-moz-range-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  box-shadow: none;\n  background-color: var(--ui-border-color-dark);\n  border-radius: 0px;\n  border: 0px solid var(--ui-border-color-dark);\n}\n\n.range::-webkit-slider-thumb {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: 0px solid var(--active-color);\n  -webkit-box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);\n  height: 21px;\n  width: 11px;\n  border-radius: 11px;\n  background: var(--active-color);\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -10px;\n}\n\n.range::-moz-range-thumb {\n  box-shadow: none;\n  border: 0px solid var(--active-color);\n  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);\n  height: 21px;\n  width: 11px;\n  border-radius: 11px;\n  background: var(--active-color);\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -10px;\n}\n\n.range::-moz-focus-outer {\n  border: 0;\n}\n\n.range-example {\n  background: black;\n  height: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
